import { render, staticRenderFns } from "./vacaciones.vue?vue&type=template&id=784fc5bc&scoped=true&"
import script from "./vacaciones.vue?vue&type=script&lang=js&"
export * from "./vacaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784fc5bc",
  null
  
)

export default component.exports